var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCash(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 40C23.5228 40 28 35.5228 28 30C28 24.4772 23.5228 20 18 20C12.4772 20 8 24.4772 8 30C8 35.5228 12.4772 40 18 40ZM18 44C25.732 44 32 37.732 32 30C32 22.268 25.732 16 18 16C10.268 16 4 22.268 4 30C4 37.732 10.268 44 18 44Z",
    fill: "url(#paint0_linear_1215_4846)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 8C27.0385 8 24.3798 9.2848 22.5458 11.3338C21.8092 12.1569 20.5448 12.2269 19.7217 11.4903C18.8987 10.7536 18.8287 9.48923 19.5653 8.66617C22.1259 5.8052 25.8535 4 30 4C37.732 4 44 10.268 44 18C44 22.1465 42.1948 25.8741 39.3338 28.4347C38.5108 29.1713 37.2464 29.1013 36.5097 28.2783C35.7731 27.4552 35.8431 26.1908 36.6662 25.4542C38.7152 23.6202 40 20.9615 40 18C40 12.4772 35.5228 8 30 8Z",
    fill: "url(#paint1_linear_1215_4846)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1215_4846",
    x1: 12.6443,
    y1: 22.9067,
    x2: 25.2308,
    y2: 27.6161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA06A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1BF78"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1215_4846",
    x1: 26.7565,
    y1: 10.153,
    x2: 37.9695,
    y2: 14.3485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA06A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1BF78"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCash);
export default __webpack_public_path__ + "static/media/cash.4fab02f976ed4fd569334fed3155ca1c.svg";
export { ForwardRef as ReactComponent };